import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { setMobileMenuOpen } from '../../Actions/Navigation.action';
import Icon from '../Icon';
import SideMenu from '../SideMenu/SideMenu';
import MobileNavigationItem from './ui/MobileNavigationItem';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Collapsible from '../Collapsible';
import MobileNavigationDropdownItem from './ui/MobileNavigationDropdownItem';

const NavigationMobile = () => {
  const dispatch = useDispatch();
  const {
    mobileMenuOpen,
    logoUrl,
    contentLinks,
    socialMediaLinks,
    topLinkList,
    channelPicker,
    retailSelectionPicker,
  } = useTypedSelector<any>((state) => state.navigation);
  const [currentLink, setCurrentLink] = useState<any>();
  const [previousLink, setPreviousLink] = useState<any>();
  const [_, setCookie] = useCookies([]);

  const Header = () => (
    <div className="flex flex-1 items-center justify-between">
      {!currentLink && (
        <>
          <img className="max-h-8" src={logoUrl} alt="Logo" />
          <div
            className="-m-4 flex h-14 w-14 cursor-pointer items-center justify-center border-l border-gray-700"
            onClick={() => dispatch(setMobileMenuOpen(false))}
          >
            <Icon className="h-5 w-5 text-white" name="close" />
          </div>
        </>
      )}
      {currentLink && (
        <>
          <div
            className="flex flex-1 cursor-pointer items-center text-white"
            onClick={onBackClick}
          >
            <Icon className="h-5 w-5 text-white" name="chevron-left" />
            <span className="text-md leading-[0]">
              {translate('general.back')}
            </span>
          </div>
          <div
            className="-m-4 flex h-14 w-14 cursor-pointer items-center justify-center border-l border-gray-700"
            onClick={() => dispatch(setMobileMenuOpen(false))}
          >
            <Icon className="h-5 w-5 text-white" name="close" />
          </div>
        </>
      )}
    </div>
  );

  function handleRetailSelectClick(
    e,
    startPageCookieValue,
    currentRegionUrl
  ) {
    e.preventDefault();
    setCookie('sp', startPageCookieValue, { path: '/', maxAge: 31536000 });
    window.location.href = `${currentRegionUrl}`;
  }

  const Content = () => (
    <div className="gap-4 p-0">
      <ul className="flex flex-col">
        {links.map((link) => (
          <MobileNavigationItem
            link={link}
            name={link.name}
            url={link.url}
            key={'mobile' + link.url + link.name}
            onLinkClick={onLinkClick}
          />
        ))}
        {topLinkList &&
          topLinkList.length > 0 &&
          topLinkList.map((link) => (
            <MobileNavigationItem
              name={link.text}
              url={link.href}
              key={'mobile' + link.href + link.text}
            />
          ))}
      </ul>
      {channelPicker?.channelPickerItems &&
        channelPicker.channelPickerItems.length > 0 && (
          <Collapsible
            className="border-t border-gray-700"
            labelClassName="text-white flex-1 p-4 lowercase capitalize !text-lg"
            key="ChannelPicker"
            label={
              <div>
                <Icon
                  name={
                    `flag-` +
                    channelPicker.currentChannel.region.toLowerCase()
                  }
                  className="mr-1.5 h-[18px] w-[18px] overflow-hidden rounded-full"
                />
                {channelPicker.currentChannel.displayName}
              </div>
            }
          >
            {channelPicker.channelPickerItems.map((item) => (
              <MobileNavigationDropdownItem
                name={item.displayName}
                url={item.url}
                region={item.region}
                key={'mobile' + item.displayName + item.code}
              />
            ))}
          </Collapsible>
        )}
      {retailSelectionPicker?.retailerSelectionItems &&
        retailSelectionPicker.retailerSelectionItems.length > 0 && (
          <Collapsible
            className="border-t border-gray-700"
            labelClassName="text-white flex-1 p-4 lowercase capitalize !text-lg"
            key="RetailSelectionPicker"
            label={
              retailSelectionPicker.currentRetailerSelection.displayName
            }
          >
            {retailSelectionPicker.retailerSelectionItems.map((item) => (
              <MobileNavigationDropdownItem
                name={item.displayName}
                url={retailSelectionPicker.currentRegionUrl}
                code={item.code}
                key={'mobile' + item.displayName + item.code}
                onLinkClick={handleRetailSelectClick}
              />
            ))}
          </Collapsible>
        )}
    </div>
  );

  const footer = () => (
    <>
      {!currentLink && (
        <div className="flex gap-4">
          {socialMediaLinks.map((link, idx) => (
            <a
              className="flex h-10 w-10 items-center justify-center rounded-full bg-white p-2"
              href={link.url}
              key={idx}
            >
              <img className="h-4 w-auto" src={link.imageUrl} />
            </a>
          ))}
        </div>
      )}
    </>
  );
  const onLinkClick = (link) => {
    link.previousLink = previousLink;
    setPreviousLink(currentLink);
    setCurrentLink(link);
  };
  const onBackClick = () => {
    setPreviousLink(previousLink?.previousLink);
    setCurrentLink(previousLink);
  };
  const links = (currentLink?.links ?? contentLinks)
    .filter((l) => !l.rightAligned)
    .sort((a, b) => (a.name > b.name ? 1 : -1));
  useEffect(() => {
    if (mobileMenuOpen) {
      setCurrentLink(null);
    }
  }, [mobileMenuOpen]);
  return (
    <>
      <SideMenu
        className="z-[60] max-w-[480px] border-gray-700 bg-black sm:border-r"
        from="left"
        id="navigation-mobile"
        open={mobileMenuOpen}
        onClosed={() => dispatch(setMobileMenuOpen(false))}
        components={{ Header, Content, Footer: footer }}
        showCloseButton={false}
      ></SideMenu>
    </>
  );
};
export default NavigationMobile;
